import React, { useState } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import CreateUpdateTalentPoolModal from "./CreateUpdateTalentPoolModal";


const PoolGroup = ({ type, groups = [], onClick, isAdding }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div>
            <p className="text-lg text-wrippleBlueGray">{type} Talent Pools</p>

            <ul className="pt-4 flex flex-col gap-2 text-wrippleBlueGray">
                {groups.map(item => {
                    return (
                        <li key={item.id}>
                            <NavLink
                                to={`/client/talent-pool/${item.id}`}
                                className={({ isActive }) => `text-xs flex items-center gap-2 ${isActive ? "!text-secondary" : ""}`}
                                onClick={onClick}
                            >
                                {({ isActive }) => (
                                    <>
                                        {/* <i className="far fa-user text-lg" /> */}
                                        <i className={`fa-user text-base ${isActive ? 'fas' : 'far'}`} />

                                        <span className="text-left">
                                            {item.name}
                                            <span
                                                className={isActive ? 'text-secondary' : 'text-gray-400'}> ({item.membersCount || item.talent_users_count})
                                            </span>
                                        </span>
                                    </>
                                )}
                            </NavLink>
                        </li>
                    )
                })}
                <li>
                    <button
                        type="button"
                        onClick={() => {
                            setIsModalOpen(true);
                            const params = new URLSearchParams(searchParams);
                            params.set('open', type);
                            return setSearchParams(params);
                        }}
                        disabled={isAdding}
                        className="text-secondary text-xs flex items-center gap-2 disabled:opacity-70"
                    >

                        <i className="fas fa-user-plus text-lg" />
                        <span>Add New {type} Talent Pool</span>
                    </button>
                </li>
            </ul>

            {isModalOpen && (
                <CreateUpdateTalentPoolModal
                    pool={{ is_personal: type === 'Personal' }}
                    onClose={() => {
                        setIsModalOpen(false)
                        const params = new URLSearchParams(searchParams);
                        params.delete('open');
                        return setSearchParams(params);
                    }}
                />
            )}
        </div>
    )
}

export default PoolGroup;